import React, { useEffect, useState } from 'react';
import Modal from '../../common/Modal';
import { DatePickerWrapper, ButtonWrapper } from './styled';
import DatePicker from '../../common/DatePicker';
import moment from 'moment';
import Button from '../../common/Button';
import { fetchExportItems, fetchGetStockByDate } from '../../../actions/items';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const EditLeftoverModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState({});
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(new Date(new Date().setHours(0, 0, 0, 0)));
  const stockByDate = useSelector((state) => state.items.stockByDate);

  const { onClose } = props;

  const { t } = useAutoTranslation();

  const handleSubmit = async () => {
    setLoading(true);
    await dispatch(fetchGetStockByDate(moment(startDate).format().slice(0, -6)));
    setLoading(false);
  };

  useEffect(() => {
    if (stockByDate !== null) {
      setLoading(true);
      if (stockByDate?.data?.errors) {
        toast.error(t('Ошибка при экспорте остатков'));
        setLoading(false);
      } else {
        setResult(stockByDate);
      }
      setLoading(false);
    }
  }, [stockByDate]);

  const handleCloseWindow = async () => {
    setResult({});
    onClose();
  };

  useEffect(() => {
    setResult({});
  }, []);

  return (
    <Modal
      loading={loading}
      title={t('Остатки на дату')}
      onClose={() => handleCloseWindow()}
      onSubmit={handleSubmit}
      customFooter={() => (
        <ButtonWrapper className="modal-footer">
          {!result?.success && (
            <Button
              onClick={handleSubmit}
              text={t('Сформировать файл')}
              className="mr-3"
              loading={loading}
            />
          )}
          {loading ? (
            <p className="text">
              {t('Формирование файла с товарами')} — <br />
              {t('пожалуйста, дождитесь окончания операции')}.
            </p>
          ) : result.success ? (
            <p className="text">
              {t('Файл сформирован')}:<a href={result.fileUrl}> {result.fileUrl}</a>
              <br />
              {t('Дата выгрузки')}:
              {moment(result.cloudUploadFinishTime).format(` DD.MM.YYYY HH:mm:SS`)},{' '}
              {t('размер файла')}: {result.fileSize}
            </p>
          ) : (
            <p className="text">{t('Файл выгрузки товаров не сформирован')}</p>
          )}
        </ButtonWrapper>
      )}
    >
      <DatePickerWrapper>
        <label>{t('Укажите дату и время для выгрузки остатков по товарам')}</label>
        <DatePicker
          selected={startDate}
          showTimeSelect
          onChange={(date) => {
            setStartDate(date);
          }}
          is24hour={true}
          dateFormat="d MMMM, yyyy HH:mm"
          locale="ru-ru"
          maxDate={new Date()}
        />
      </DatePickerWrapper>
    </Modal>
  );
};

export default EditLeftoverModal;
